module.exports = __webpack_public_path__ + "static/img/Bulldogs.4d6a6b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bulldogs.svg
// module id = aeyP
// module chunks = 0